import { numberWithCommas, unlimitedParse } from '@callrail/looky/util';

import { platformDisplayInfo } from '../interfaces/plan-display-info';
import { PlatformPricing } from '../interfaces/platform-pricing';
import { ProductType } from '../type-aliases/product-type';
import { PlatformModel } from './platform.model';

export class FormsPlatformModel extends PlatformModel {
  public submissions: PlatformPricing;

  public platform: ProductType = 'forms';

  public platformInfo = platformDisplayInfo[this.platform];

  public displayText;

  constructor(platformPlan) {
    super(platformPlan);
    Object.assign(this, platformPlan);
    this.setDisplayText();
  }

  public get _usageInfo(): string[] {
    return [
      `${this.submissions.included_units} form submissions per month; \
      $${this.submissions.additional_price} each additional`,
    ];
  }

  public get _unitPrice(): number {
    return this.price;
  }

  private setDisplayText() {
    this.displayText = {
      marketingCopyA: `Includes ${numberWithCommas(
        unlimitedParse(this.submissions?.included_units)
      )} form submissions`,
      marketingCopyB: `Custom form builder`,
      marketingCopyC: `Form scoring`,
    };
  }
}
